/* Accounts are an interaction, stored as "type" : "account"
 *  If userType is admin, this component should fetch a list of all account interactions
 *  If userType is doctor/clinician, this component should load up to THEIR account page
 *  Account-type interactions can only have pathways as children
 *    (and the Account drilldown screen will look different from other interaction screens)
 */

import { useEffect, useState } from "react";
import Interaction from "../models/interactions/Interaction";
import Immutable from "immutable";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import "./styles/Accounts.css";
import TextField from "@mui/material/TextField";
import { compareInteractionsByTitle } from "../helpers/DataUpdateHelper";
import { createSelector } from "reselect";

import AddChildInteractionButton from "../components/interactions/AddChildInteractionButton";
import { useNavigate } from "react-router-dom";
import { useStoreSelector } from "../store/Hooks";
import CommitButton from "../components/commit/CommitButton";
import { postgrest_operators } from "../helpers/HttpHelper";
import { RootState } from "../store/Store";
import { useTranslation } from "react-i18next";

const filteredAccountSelector: (
  state: RootState,
  accountSearchName: string,
) => Immutable.List<Interaction> = createSelector(
  (state: RootState) => state.tables.accounts.toList(),
  (_: RootState, accountSearchName: string) => accountSearchName,
  (accounts: Immutable.List<Interaction>, accountSearchName: string) =>
    accounts
      .filter((account) =>
        account.title.toLowerCase().includes(accountSearchName.toLowerCase()),
      )
      .sort(compareInteractionsByTitle),
);

const Accounts = () => {
  const [accountSearchName, setAccountSearchName] = useState("");
  const accounts: Immutable.List<Interaction> = useStoreSelector((state) =>
    filteredAccountSelector(state, accountSearchName),
  );

  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    Interaction.queryTable([
      {
        operator: postgrest_operators.eq,
        column: "properties->>type",
        value: "account",
      },
    ]);
  }, []);

  return (
    <div style={{ width: "95%", margin: "auto", minHeight: "62vh" }}>
      {accounts && accounts.size > 0 && <div style={{ paddingTop: "30px" }}>
        <h1 style={{ width: "100%",marginTop:"-5px", textAlign: "left", color: "#1976d2" }}>
          Accounts
        </h1>
        <TextField
          style={{ float: "left", width: "350px" }}
          id="outlined-controlled"
          label={t("search_accounts_label")}
          value={accountSearchName}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setAccountSearchName(event.target.value);
          }}
        />
        &nbsp;&nbsp;
        <AddChildInteractionButton
          setID={null}
          parentID={null}
          type="accounts"
          main={false}
          numChildren={0}
          intervalSetID={null}
        />
      </div>}

      <List
        className={"accountsListItem"}
        style={{
          paddingBottom: "30px",
          color: "#1565c0",
          fontWeight: "bolder",
        }}
        dense={false}
        sx={{ width: "95%", margin: "auto" }}
      >
        {accounts && accounts.size > 0 && accounts.map((account) => {
          return (
            <ListItem
              key={account.id}
              sx={{
                "&:hover": {
                  backgroundColor: "#1976d2",
                  color: "white",
                  cursor: "pointer",
                  borderRadius: "10px 10px",
                },
              }}
              onClick={() => {
                navigate("/contents/s" + account.id + "p" + account.id);
              }}
            >
              <ListItemAvatar>
                <Avatar>
                  {/* down the road, this can be the logo we set for the client site */}
                  <ContactPageIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={account.title} />
            </ListItem>
          );
        })}
      </List>
      {!accounts || accounts.size < 1 && <h1 style={{ color: "#1976d2", width: "100%", textAlign: "center" }}>
        No existing accounts.
        <br />Click &nbsp;  <AddChildInteractionButton
          setID={null}
          parentID={null}
          type={"accounts"}
          main={false}
          demo={true}
          numChildren={0}
          intervalSetID={null} />
        to create a new account. </h1>}

    </div>
  );
};

export default Accounts;
